import Checkbox from "../checkbox";
import fragilePackingImg from "/public/images/fragile-packing.png";
import mobileFragilePackingImg from "/public/images/mobile-fragile-packing.png";
import Image from "next/image";

export default function FragilePackingNotice() {
  return (
    <>
      <div className="bg-bg-purple flex flex-col md:flex-row md:mt-0 pt-10 md:pt-6 md:pb-6">
        <div className="md:w-[40%] md:text-[14px] text-center md:text-left mb-4 md:mb-0 px-6">
          <p className="font-semibold">Opted for fragile packing?</p>
          <br />
          <p>
            Note that a bigger box will be needed to fit fragile packing
            materials. This will increase shipping costs.
          </p>
          <br />
          <p>
            The exact padding required depends on the number of fragile items,
            the shape of the items, and how fragile they are.
          </p>
          <div className="hidden md:flex items-center mt-4">
            <Checkbox
              id="fragile-do-not-show-again"
              label="Do not show this again"
              containerClassName="flex items-center mt-1 justify-self-end"
              onChange={(e) => {
                try {
                  localStorage.setItem(
                    "fragile-notice-dismissed",
                    e.target.checked
                  );
                } catch (err) {}
              }}
            />
          </div>
        </div>
        <div className="w-[60%] place-self-center hidden md:block">
          <Image src={fragilePackingImg} alt="Fragile Packing" />
        </div>
        <div className="place-self-center md:hidden bg-bg-purple px-3">
          <Image src={mobileFragilePackingImg} alt="Fragile Packing" />
        </div>
        <div className="px-6 md:hidden">
          <p className="text-center">
            Account for extra space needed for{" "}
            <span className="text-pink">fragile packing materials.</span>
          </p>
          <div className="text-center mt-6">
            <Checkbox
              label="Do not show this again"
              id="mobile-fragile-do-not-show-again"
              containerClassName="flex items-center mt-1"
              onChange={(e) => {
                try {
                  localStorage.setItem(
                    "fragile-notice-dismissed",
                    e.target.checked
                  );
                } catch (err) {}
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
